import React   from 'react';
import PropTypes from "prop-types";
import cn from "classnames";
import { useFormContext, useController } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import { getUUID } from "../../lib/utils/common";

const FloatingInput = ({ id, labelText, inputRef, errors, name, isRequired, ...inputProps }) => {
  return (
    <div className='form-floating'>
      <input
        id={id}
        ref={inputRef}
        {...inputProps}
      />
      <label htmlFor={id} className={cn({ required: isRequired })}>
        {labelText}
      </label>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <div className="invalid-feedback">
            {message}
          </div>
        )}
      />
    </div>
  )
}

const BaseInput = ({ id, labelText, inputRef, errors, name, isRequired, ...inputProps }) => {
  return (
    <>
      <label htmlFor={id} className={cn("form-label", { required: isRequired })}>
        {labelText}
      </label>
      <input
        ref={inputRef}
        id={id}
        {...inputProps}
        value={inputProps.value ?? ''}
      />
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <div className="invalid-feedback">
            {message}
          </div>
        )}
      />
    </>
  )
}


const Input = (
  { labelText,
    type,
    name,
    handleChange,
    placeholder,
    floating = false,
    isRequired = false,
    defaultValue = undefined
  }) => {
  const id = getUUID()
  const { control } = useFormContext();
  const {
    field: { ref, onBlur, ...inputProps },
    fieldState: { invalid },
    formState: { errors }
  } = useController({ name, control, defaultValue })

  const onBlurExtend = e => {
    const value = e.currentTarget.value
    onBlur()
    if(handleChange) {
      handleChange(name, value)
    }
  }

  const mainProps = {
    className: cn('form-control', {'is-invalid': invalid }),
    onBlur: onBlurExtend,
    labelText,
    placeholder,
    type,
    id,
    errors,
    name,
    isRequired,
    inputRef: ref,
    ...inputProps,
  }

  return (
    floating
        ? <FloatingInput {...mainProps} />
        : <BaseInput {...mainProps} />
  )
}

Input.propTypes = {
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  handleChange: PropTypes.func,
  floating: PropTypes.bool,
  placeholder: PropTypes.string,
}

export default Input